import { laborProtectionApi } from "@/getinfo-api";
import { EducationProtocolExport } from "@/api-v2/labor-protection/models/education-protocol-export";
import { ExportStatusEnum } from "@/api-v2/import-export-2/models";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

export class LaborExportClass {
  static async precheck(form: EducationProtocolExport) {
    try {
      const {
        data
      } = await laborProtectionApi.EducationProtocol.preChecksExportEducationProtocol(
        form
      );

      return data?.multiplyContractors?.filter(el => !el.isValid);
    } catch (e) {
      console.warn(e);
    }
  }

  static async startExport(form: EducationProtocolExport, fileName: string) {
    form.path = `Протоколы обучения/Выгрузка в реестр по ОТ/${fileName}`;
    const {
      data
    } = await laborProtectionApi.EducationProtocol.exportEducationProtocol(
      form
    );

    return data;
  }

  static getExportStatus(status: ExportStatusEnum) {
    const result = {
      variant: "warning",
      text: `${i18n.tc(LocalesFields.Unknown)}`
    };

    if (status === ExportStatusEnum.Waiting) {
      result.text = `${i18n.tc(LocalesFields.InProcessing)}`;
      result.variant = "warning";
    }

    if (status === ExportStatusEnum.Started) {
      result.text = `${i18n.tc(LocalesFields.InProcessing)}`;
      result.variant = "info";
    }

    if (status === ExportStatusEnum.Success) {
      result.text = `${i18n.tc(LocalesFields.Success)}`;
      result.variant = "success";
    }

    if (status === ExportStatusEnum.Fail) {
      result.variant = "danger";
      result.text = `${i18n.tc(LocalesFields.Error)}`;
    }

    return result;
  }

  static async getDetailInfo(id: string) {
    const {
      data
    } = await laborProtectionApi.EducationProtocol.getExportEducationProtocol(
      id
    );
    return data;
  }
}
